import {
  GET_OTP_INIT,
  GET_OTP_SUCCESS,
  GET_OTP_FAILURE,
  VERIFY_OTP_INIT,
  VERIFY_OTP_SUCCESS,
  VERIFY_OTP_FAILURE,
  FIREBASE_SIGNED_OUT,
  GET_USER_INIT,
  GET_USER_SUCCESS,
  GET_USER_FAILURE,
  CLIENT_ONBOARDING_INIT,
  CLIENT_ONBOARDING_SUCCESS,
  CLIENT_ONBOARDING_FAILURE,
  RESET_OTP,
} from "../actionTypes";

export const getOTPSuccess = (data: any) => {
  return {
    type: GET_OTP_SUCCESS,
    data,
  };
};

export const getOTPFailure = (error: any) => {
  return {
    type: GET_OTP_FAILURE,
    error,
  };
};

export const getOTP = (params: any) => {
  const payload = { params };
  return {
    type: GET_OTP_INIT,
    payload,
  };
};

export const verifyOTPSuccess = (data: any) => {
  return {
    type: VERIFY_OTP_SUCCESS,
    data,
  };
};

export const verifyOTPFailure = (error: any) => {
  return {
    type: VERIFY_OTP_FAILURE,
    error,
  };
};

export const verifyOTP = (params: any) => {
  const payload = { params };
  return {
    type: VERIFY_OTP_INIT,
    payload,
  };
};

export const firebaseSignedOut = () => {
  return {
    type: FIREBASE_SIGNED_OUT,
  };
};

export const getUserSuccess = (data: any) => {
  return {
    type: GET_USER_SUCCESS,
    data,
  };
};

export const getUserFailure = (error: any) => {
  return {
    type: GET_USER_FAILURE,
    error,
  };
};

export const getUser = (params: any) => {
  const payload = { params };
  return {
    type: GET_USER_INIT,
    payload,
  };
};

export const clientOnboardingSuccess = (data: any) => {
  return {
    type: CLIENT_ONBOARDING_SUCCESS,
    data,
  };
};

export const clientOnboardingFailure = (error: any) => {
  return {
    type: CLIENT_ONBOARDING_FAILURE,
    error,
  };
};

export const clientOnboarding = (params: any) => {
  const payload = { params };
  return {
    type: CLIENT_ONBOARDING_INIT,
    payload,
  };
};

export const resetOtp = (params: any) => {
  return {
    type: RESET_OTP,
    params,
  };
};
